import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useCourseSeries = ({
    seriesId
}) => {

    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url } = hooks.useApi()

    const { data, isLoading } = useQuery(
        [cacheKeys.COURSES, seriesId],
        () => api.get(url(endpoints.series, { seriesId })),
        { enabled: seriesId }
    )

    return {
        isLoadingSeries: isLoading,
        series: data || {}
    }
}

export default useCourseSeries
